"use client";

import { useAuth } from "@/providers/auth.provider";
import ChatwootIntegration from "@/lib/cs/chatwootSDK";
import { useEffect, useState } from "react";
import { usePathname } from "next/navigation";

export const Chatwoot = () => {
  const [chatwootUserInfo, setChatwootUserInfo] = useState<User | undefined>();
  const { user } = useAuth();
  const pathName = usePathname();

  useEffect(() => {
    setChatwootUserInfo(user);
  }, [user]);

  if (
    pathName.includes("login") ||
    pathName.includes("verify") ||
    pathName.includes("onboarding")
  ) {
    return null;
  }

  return <ChatwootIntegration user={chatwootUserInfo} />;
};
